import { Component, OnInit } from '@angular/core';
import * as Mock from 'mockjs';
@Component({
  selector: 'ecp-data-table',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {


  constructor() { }

  ngOnInit() {
  }

}
